import { Link } from 'react-router-dom'
import Text from '../../shared/textStyleDefault/texto'
import React from 'react'

interface BotonServicioProps {
  texto: string
  to: string
}

const BotonServicio = ({ texto, to }: BotonServicioProps): JSX.Element => {
  return (
    <Link
      to={to}
      className="w-auto max-w-[280px] md:max-w-max h-[40px] md:w-fit md:h-[60px] px-[26px] py-2.5 md:px-10 md:py-4 bg-blue-400 rounded-lg inline-flex justify-center items-center gap-[6px] md:gap-2.5 overflow-hidden whitespace-nowrap text-ellipsis no-underline hover:bg-blue-500 transition"
    >
      <Text variant='button' as='button' className='justify-start tracking-tight overflow-hidden text-ellipsis text-[#1E1E1E]'>
        {texto}
      </Text>
    </Link>
  )
}

export default BotonServicio
